import type { ComponentPropsWithoutRef, FC } from 'react';
import { cn } from 'src/utils/cn';

type HintProps = ComponentPropsWithoutRef<'aside'> & {
  size?: 'sm' | 'md';
};

export const Hint: FC<HintProps> = ({ size = 'md', ...props }) => (
  <aside
    {...props}
    className={cn(
      `
        inline-block
        not-legacy:text-foreground-surface-subdued
        legacy:text-legacy-brand-light-2
      `,
      size === 'sm' &&
        `
          not-legacy:text-body-sm
          legacy:text-legacy-xs
        `
    )}
  />
);
